import React, { useState, useEffect } from 'react';
import {Link} from 'react-router-dom';
import { DownloadOutlined } from '@ant-design/icons';
import '../../css/documentationTable.css';

export const DocumentationTable = ({ documents }) => {
    const [fileSizes, setFileSizes] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Функция для получения размера файла
    const getFileSize = async (url) => {
        try {
            const response = await fetch(url, { method: 'HEAD' });
            if (response.ok) {
                const size = response.headers.get('Content-Length');
                return size ? parseInt(size, 10) : null;
            }
            return null;
        } catch (error) {
            console.error('Ошибка при получении размера файла:', error);
            return null;
        }
    };

    // Функция для форматирования размера файла (MB или KB)
    const formatFileSize = (bytes) => {
        if (!bytes || bytes === 0) return '0 KB';

        const k = 1024;
        const mb = bytes / (k * k); // Convert to MB

        if (mb >= 1) {
            return `${mb.toFixed(2)} MB`;
        } else {
            const kb = bytes / k; // Convert to KB
            return `${kb.toFixed(2)} KB`;
        }
    };

    // Загрузка размеров файлов при монтировании компонента
    useEffect(() => {
        const loadFileSizes = async () => {
            try {
                setLoading(true);
                const sizes = {};

                for (const doc of documents) {
                    const path = `${doc.url}.${doc.type}`
                    const sizeInBytes = await getFileSize(path);
                    sizes[path] = sizeInBytes !== null ?
                        formatFileSize(sizeInBytes) : 'Неизвестно';
                }

                setFileSizes(sizes);
                setError(null);
            } catch (err) {
                setError('Не удалось загрузить информацию о размерах файлов');
                console.error('Ошибка:', err);
            } finally {
                setLoading(false);
            }
        };

        loadFileSizes();
    }, [documents]);

    return (
        <div className="documentation-container">
            <section className="documentation-section">
                <table className="doc-table">
                    <tbody>
                    {documents.map((doc, index) => (
                        <tr key={index}>
                            <td className="doc-name">
                                <span className="doc-title">{doc.num}</span>
                            </td>

                            <td className="doc-name">
                                <span className="doc-title">{doc.name}</span>
                            </td>

                            <td className="doc-type">
                                <span className="type-badge">{doc.type}</span>
                            </td>

                            <td className="doc-type">
                                <Link
                                    to={`${doc.url}.${doc.type}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="doc-link"
                                >
                                    Открыть
                                </Link>
                            </td>

                            <td className="doc-action">
                                <span className="doc-size">
                                    {loading ? 'Загрузка...' : fileSizes[`${doc.url}.${doc.type}`] || 'Неизвестно'}
                                </span>
                                <a
                                    href={`${doc.url}.${doc.type}`}
                                    download
                                    className="download-link"
                                    title="Скачать документ"
                                >
                                    <DownloadOutlined />
                                </a>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>

                {error && (
                    <div className="error-message">
                        {error}
                    </div>
                )}
            </section>
        </div>
    );
};